import { $el, $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const RECIPIENT_FORM_CHECKBOX_SELECTOR = `[data-recipient-form-checkbox]`
const RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR = `[data-recipient-form-timezone-input]`
const RECIPIENT_FORM_INPUT_SELECTOR = '[data-recipient-form-input]'
const RECIPIENT_FORM_FIELDS_SELECTOR = '[data-recipient-form-fields]'

export class RecipientForm extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'change', this.handleChange)
  }

  handleChange(): void {
    const checkbox: HTMLInputElement = $el(
      RECIPIENT_FORM_CHECKBOX_SELECTOR,
      this,
    )

    this.updateHeight(checkbox.checked)
    this.updateDisable(!checkbox.checked)

    if (!checkbox.checked) {
      this.clearInputs()
    }
  }

  clearInputs(): void {
    const inputs: HTMLInputElement[] = $list(
      `${RECIPIENT_FORM_INPUT_SELECTOR}, ${RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR}`,
      this,
    )

    inputs.forEach(input => {
      input.value = ''
    })
  }

  updateDisable(isDisabled: boolean): void {
    const inputs: HTMLInputElement[] = $list(
      `${RECIPIENT_FORM_INPUT_SELECTOR}, ${RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR}`,
      this,
    )

    inputs.forEach(field => {
      field.disabled = isDisabled
    })
  }

  reset(): void {
    const checkbox: HTMLInputElement = $el(
      RECIPIENT_FORM_CHECKBOX_SELECTOR,
      this,
    )

    checkbox.checked = false
    this.clearInputs()
  }

  updateHeight(isChecked: boolean): void {
    const fields = $el(RECIPIENT_FORM_FIELDS_SELECTOR, this)
    if (fields) {
      fields.style.maxHeight = `${isChecked ? fields.scrollHeight : 0}px`
    }
  }

  setTimezone() {
    const timezoneInput: HTMLInputElement = $el(
      RECIPIENT_FORM_TIMEZONE_INPUT_SELECTOR,
      this,
    )
    timezoneInput.value = String(new Date().getTimezoneOffset())
  }
}
